import config from '../../config';
import {
  INewSingleProductData,
  IProduct,
  IProductDetails,
  IProductPrice,
  IProductPrices,
} from '../common/interfaces/products.interface';
import OldFormatHelper from '@/helpers/OldFormatHelper';
import CustomerHelper from '@/helpers/CustomerHelper';
import { ICalendarDoorProduct } from '@/common/interfaces/announcement-bar.interface';

export default class ProductHelper {
  public static discountOrSoldOutImage(isPartner: boolean, product: IProduct): string {
    if(product.soldOut) {
      return config.products.images.soldOut;
    }
    const percentage = isPartner ? product.prices.partner.discountPercentage : product.prices.customer.discountPercentage;
    const { availableDiscounts } = config.products;

    if(percentage && availableDiscounts.indexOf(percentage) >= 0) {
      // since percentage is included in availableDiscounts it is a valid index of config.products.images
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return config.products.images[percentage];
    }
    return ``;
  }

  public static getPriceUnformatted(isPartner: boolean, prices: IProductPrices): number | string {
    if(!prices || !prices.customer || !prices.customer.brutto) {
      return ``;
    }
    return isPartner ? prices.partner.brutto : prices.customer.brutto;
  }

  public static getMaxAmountForProduct(item: IProduct): number {
    if(item.singleShipmentOnly) {
      return 1;
    }
    if(!item.maxPerCart) {
      return 99;
    }
    return item.maxPerCart;
  }

  public static getMyPrice(productInfo: IProduct | ICalendarDoorProduct, isPartner = false, showCurrency = true): string {
    if(!productInfo.prices.customer.brutto) {
      return ``;
    }

    let price = isPartner
      ? productInfo.prices.partner.brutto
      : productInfo.prices.customer.brutto;

    if(!price) {
      price = 0;
    }

    return showCurrency ? OldFormatHelper.getPrice(price) : price.toFixed(2).replace(`.`, `,`);
  }

  public static getMyOriginalPrice(productInfo: IProduct | ICalendarDoorProduct, isPartner = false, showCurrency = true): string {
    if(!productInfo.prices.customer.bruttoWithoutDiscount) {
      return ``;
    }

    let price = isPartner
      ? productInfo.prices.partner.bruttoWithoutDiscount
      : productInfo.prices.customer.bruttoWithoutDiscount;

    if(!price) {
      price = 0;
    }

    return showCurrency ? OldFormatHelper.getPrice(price) : price.toFixed(2).replace(`.`, `,`);
  }

  public static transformZapiProductAndPapiProductToProductDetails(zapiProductData: IProduct, singleProductData: INewSingleProductData): IProductDetails {
    const price: IProductPrice = CustomerHelper.getPartnerStatus() ? zapiProductData.prices.partner : zapiProductData.prices.customer;
    return {
      amount: parseFloat(zapiProductData.contentsAmount),
      basePrice: zapiProductData.basePrice,
      categories: singleProductData.categories,
      description: singleProductData.usp,
      discountPrice: price.bruttoWithoutDiscount ? price.brutto : -1,
      images: [],
      informationLinkColor: singleProductData.informationLinkColor,
      matchcode: zapiProductData.matchcode,
      price: price.bruttoWithoutDiscount ? price.bruttoWithoutDiscount : price.brutto,
      slug: zapiProductData.link.split(`/`)[2],
      title: singleProductData.title,
      unit: zapiProductData.unitContents,
    };
  }
}
